import { COLORS } from "../theme";

export const boxShadowFocusStyles = {
  boxShadow: `0px 0px 0px 2px ${COLORS.gray900}, 0px 0px 0px 4px ${COLORS.gray50}`,
};

export const boxShadowErrorStyles = {
  boxShadow: `0px 0px 0px 2px ${COLORS.gray900}, 0px 0px 0px 4px ${COLORS.red400}`,
};
